export const websiteIds = Object.freeze({
    WOODEN_BLINDS_DIRECT: 101,
    CUSTOM_CURTAINS: 102,
    ROMAN_BLINDS_DIRECT: 103,
    POLES_DIRECT: 104,
    VERTICAL_BLINDS_DIRECT: 105,
    ROLLER_BLINDS_DIRECT: 106,
    SHUTTERS_DIRECT: 107,
    PLEATED_BLINDS_DIRECT: 108,
    BLINDS_DIRECT: 116,
    WILSONS_BLINDS: 117,
    BLINDS_DIRECT_IE: 118,
});
